import React, { useState } from 'react';
import * as Popover from '@radix-ui/react-popover';
import { HexColorPicker } from 'react-colorful';
import './ColorPicker.css';

const ColorPicker = ({ color = '#FF1493', onChange, label }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [tempColor, setTempColor] = useState(color);

  const handleColorChange = (newColor) => {
    setTempColor(newColor);
    onChange(newColor);
  };

  const presetColors = [
    '#FF1493', // Deep Pink (KNKT Primary)
    '#FF69B4', // Hot Pink
    '#000000', // Black
    '#FFFFFF', // White
    '#1a1a1a', // Dark Gray
    '#333333', // Medium Gray
    '#666666', // Light Gray
    '#FF0000', // Red
    '#00FF00', // Green
    '#0000FF', // Blue
    '#FFFF00', // Yellow
    '#FF00FF', // Magenta
    '#00FFFF', // Cyan
    '#FFA500', // Orange
    '#800080', // Purple
    '#008080', // Teal
  ];

  return (
    <div className="color-picker-wrapper">
      {label && <label className="color-picker-label">{label}</label>}
      <Popover.Root open={isOpen} onOpenChange={setIsOpen}>
        <Popover.Trigger asChild>
          <button type="button" className="color-picker-trigger">
            <div
              className="color-swatch"
              style={{ backgroundColor: color }}
            />
            <span className="color-value">{color}</span>
          </button>
        </Popover.Trigger>

        <Popover.Portal>
          <Popover.Content
            className="color-picker-content"
            sideOffset={5}
            align="start"
          >
            <div className="color-picker-inner">
              <HexColorPicker
                color={tempColor}
                onChange={handleColorChange}
              />

              <div className="color-presets">
                <div className="color-presets-label">Presets</div>
                <div className="color-presets-grid">
                  {presetColors.map((presetColor) => (
                    <button
                      key={presetColor}
                      type="button"
                      className={`color-preset-swatch ${tempColor === presetColor ? 'active' : ''}`}
                      style={{ backgroundColor: presetColor }}
                      onClick={() => handleColorChange(presetColor)}
                      title={presetColor}
                    />
                  ))}
                </div>
              </div>

              <div className="color-input-wrapper">
                <input
                  type="text"
                  value={tempColor}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^#[0-9A-Fa-f]{0,6}$/.test(value)) {
                      handleColorChange(value);
                    }
                  }}
                  className="color-hex-input"
                  placeholder="#FF1493"
                />
              </div>
            </div>
            <Popover.Arrow className="color-picker-arrow" />
          </Popover.Content>
        </Popover.Portal>
      </Popover.Root>
    </div>
  );
};

export default ColorPicker;
